window.addEventListener('load', function() {
  var stickyIcons = document.querySelectorAll('[data-vtimefrom]');

  function doActions() {
    let theTimeNow = new Date().getTime();
    for(let i = 0; i < stickyIcons.length; i++) {

      let from = new Date();
      from.setUTCHours(...stickyIcons[i].dataset.vtimefrom.split(':'));

      let to = new Date();
      to.setUTCHours(...stickyIcons[i].dataset.vtimeto.split(':'));

      stickyIcons[i].style.display = (theTimeNow > from.getTime() && theTimeNow < to.getTime()) ? 'initial' : 'none'
      /*console.log(stickyIcons[i])
      console.log(`done using -> (${theTimeNow} > ${from.getTime()} (${theTimeNow > from.getTime()}) && ${theTimeNow} < ${to.getTime()} (${theTimeNow < to.getTime()}))`)*/
    }
  }

  doActions();
  setInterval(() => doActions(), 10000)
})
